/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';

export class __unstableRichTextInputEvent extends Component {
	render() {
		return null;
	}
}
